// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-header {
  position: sticky;
  top: 0;
  z-index: 50;
  /* Liquid glass (Aero) effect similar to .info-card */
  background: linear-gradient(135deg, rgba(255, 245, 247, 0.55), rgba(255, 255, 255, 0.35));
  backdrop-filter: blur(10px) saturate(120%);
  -webkit-backdrop-filter: blur(10px) saturate(120%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 6px 18px rgba(2, 12, 6, 0.06), inset 0 1px 0 rgba(255,255,255,0.5);
  min-height: 76px; /* fixed min height so layout doesn't jump */
}

.site-header-inner {
  display: flex;
  align-items: center; /* vertically center brand and nav */
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px; /* consistent padding */
  min-height: 76px; /* enforce height for perfect centering */
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 800;
  color: var(--color-text);
  text-decoration: none;
  font-size: 24px; /* larger brand text */
  line-height: 1; /* avoid extra vertical offset */
}

/* Removed brand-mark placeholder to avoid reserving space for logo */

.nav {
  display: flex;
  align-items: center; /* vertically center the search/logo */
  gap: 10px;
}

.nav-link {
  color: var(--color-text);
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 8px;
}

.nav-link:hover {
  background: #f1f5f9;
}

.nav-cta {
  background: var(--color-primary);
  color: #ffffff;
  border: 1px solid var(--color-primary-700);
  padding: 8px 12px;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.2s ease;
  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.28);
}

.nav-cta:hover {
  transform: translateY(-1px);
  background: var(--color-primary-500);
}

.search {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(248, 250, 252, 0.7);
  border: 1px solid rgba(229, 231, 235, 0.8);
  border-radius: 999px;
  padding: 6px 12px;
  height: 42px; /* consistent height */
}

.search-box:focus-within {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.12);
}

.search input {
  height: 38px; /* better vertical alignment inside 42px box */
  border: none;
  outline: none;
  background: transparent;
  padding: 0 4px;
  width: 320px;
  line-height: 1.2;
}

.search input:focus {
  outline: none;
}

.nav-logo {
  width: 80px; /* larger logo */
  height: 80px;
  object-fit: contain;
  margin-left: 8px;
}

/* Hidden by default; used only on mobile for inner pages */
.header-center {
  display: none;
}

/* Mobile specific: center brand text */
@media (max-width: 430px) {
  .site-header-inner {
    justify-content: center;
  }
  .nav {
    position: absolute;
    right: 12px;
  }
  /* Hide navbar search on mobile; home shows its own below banner */
  .site-header .search {
    display: none !important;
  }
  /* Hide brand text on inner pages, show centered logo */
  .site-header.is-inner .brand {
    visibility: hidden;
    pointer-events: none;
  }
  /* Show centered logo and hide right logo on mobile */
  .site-header .nav-logo { display: none; }
  .site-header.is-inner .header-center {
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .site-header.is-inner .header-center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .site-header.is-inner .header-logo {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qDAAqD;EACrD,yFAAyF;EACzF,0CAA0C;EAC1C,kDAAkD;EAClD,iDAAiD;EACjD,gFAAgF;EAChF,gBAAgB,EAAE,4CAA4C;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,8BAA8B;EAC9B,SAAS;EACT,kBAAkB,EAAE,uBAAuB;EAC3C,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe,EAAE,sBAAsB;EACvC,cAAc,EAAE,gCAAgC;AAClD;;AAEA,qEAAqE;;AAErE;EACE,aAAa;EACb,mBAAmB,EAAE,sCAAsC;EAC3D,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,6EAA6E;EAC7E,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,YAAY,EAAE,sBAAsB;AACtC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,YAAY,EAAE,8CAA8C;EAC5D,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,gBAAgB;EAC7B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA,kEAAkE;EAClE;IACE,wBAAwB;EAC1B;EACA,uDAAuD;EACvD;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA,qDAAqD;EACrD,yBAAyB,aAAa,EAAE;EACxC;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":[".site-header {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  /* Liquid glass (Aero) effect similar to .info-card */\n  background: linear-gradient(135deg, rgba(255, 245, 247, 0.55), rgba(255, 255, 255, 0.35));\n  backdrop-filter: blur(10px) saturate(120%);\n  -webkit-backdrop-filter: blur(10px) saturate(120%);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow: 0 6px 18px rgba(2, 12, 6, 0.06), inset 0 1px 0 rgba(255,255,255,0.5);\n  min-height: 76px; /* fixed min height so layout doesn't jump */\n}\n\n.site-header-inner {\n  display: flex;\n  align-items: center; /* vertically center brand and nav */\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 16px; /* consistent padding */\n  min-height: 76px; /* enforce height for perfect centering */\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 800;\n  color: var(--color-text);\n  text-decoration: none;\n  font-size: 24px; /* larger brand text */\n  line-height: 1; /* avoid extra vertical offset */\n}\n\n/* Removed brand-mark placeholder to avoid reserving space for logo */\n\n.nav {\n  display: flex;\n  align-items: center; /* vertically center the search/logo */\n  gap: 10px;\n}\n\n.nav-link {\n  color: var(--color-text);\n  text-decoration: none;\n  padding: 8px 12px;\n  border-radius: 8px;\n}\n\n.nav-link:hover {\n  background: #f1f5f9;\n}\n\n.nav-cta {\n  background: var(--color-primary);\n  color: #ffffff;\n  border: 1px solid var(--color-primary-700);\n  padding: 8px 12px;\n  border-radius: 999px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.2s ease;\n  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.28);\n}\n\n.nav-cta:hover {\n  transform: translateY(-1px);\n  background: var(--color-primary-500);\n}\n\n.search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(248, 250, 252, 0.7);\n  border: 1px solid rgba(229, 231, 235, 0.8);\n  border-radius: 999px;\n  padding: 6px 12px;\n  height: 42px; /* consistent height */\n}\n\n.search-box:focus-within {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.12);\n}\n\n.search input {\n  height: 38px; /* better vertical alignment inside 42px box */\n  border: none;\n  outline: none;\n  background: transparent;\n  padding: 0 4px;\n  width: 320px;\n  line-height: 1.2;\n}\n\n.search input:focus {\n  outline: none;\n}\n\n.nav-logo {\n  width: 80px; /* larger logo */\n  height: 80px;\n  object-fit: contain;\n  margin-left: 8px;\n}\n\n/* Hidden by default; used only on mobile for inner pages */\n.header-center {\n  display: none;\n}\n\n/* Mobile specific: center brand text */\n@media (max-width: 430px) {\n  .site-header-inner {\n    justify-content: center;\n  }\n  .nav {\n    position: absolute;\n    right: 12px;\n  }\n  /* Hide navbar search on mobile; home shows its own below banner */\n  .site-header .search {\n    display: none !important;\n  }\n  /* Hide brand text on inner pages, show centered logo */\n  .site-header.is-inner .brand {\n    visibility: hidden;\n    pointer-events: none;\n  }\n  /* Show centered logo and hide right logo on mobile */\n  .site-header .nav-logo { display: none; }\n  .site-header.is-inner .header-center {\n    display: block;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .site-header.is-inner .header-center {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .site-header.is-inner .header-logo {\n    width: 80px;\n    height: 80px;\n    object-fit: contain;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
